import { SylPlugin } from '@syl-editor/core-utilities';
import LinkController from './controller';
import DIYLink from './schema';

export default class LinkPlugin extends SylPlugin<any> {
  public name = 'diyLink';

  public Controller = LinkController;

  public Schema = DIYLink;
}
